import {
  IconAccountAddress,
  IconAccountDashboard,
  IconAccountOrder,
  IconAccountProfile,
  IconAccountWishlist,
} from "@repo/assets/images";

export const ACCOUNT_MENU = {
  AccountSettings: [
    {
      id: 1,
      url: "/account/profile",
      name: "profile",
      label: "Personal_Details",
      icon: IconAccountProfile,
    },
    {
      id: 2,
      url: "/account/address",
      name: "address",
      label: "Address_Book",
      icon: IconAccountAddress,
    },
  ],
  Products: [
    {
      id: 1,
      url: "/account/orders",
      name: "orders",
      label: "Orders",
      icon: IconAccountOrder,
    },
    {
      id: 2,
      url: "/account/favourites",
      name: "favourites",
      label: "Favourites",
      icon: IconAccountWishlist,
    },
  ],
  DasboardLinks: [
    {
      id: 1,
      url: "/account",
      label: "General",
      name: "general",
      icon: IconAccountDashboard,
    },
  ],
};

const ORDERSTATUS_POSITIVE_STYLE =
  "text-mediumgreen bg-lightgreen border-darkgreen border";
const ORDERSTATUS_NEGATIVE_STYLE =
  "text-[#D32F2F] bg-[#FAEAEA] border-[#C62828] border";

// TODO: Remove the commented code once the order statuses are finalized
// Map order statuses to text and styles
/*
export const STATUS_MAP = {
  PAYMENT_SUCCESS: {
    text: "Processing",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PAYMENT_FAILED: { text: "Failed", style: ORDERSTATUS_NEGATIVE_STYLE },
  CANCELLED: { text: "Cancelled", style: ORDERSTATUS_NEGATIVE_STYLE },
  SHIPPED: { text: "Shipped", style: ORDERSTATUS_POSITIVE_STYLE },
  AWAITING_SHIPMENT: {
    text: "Awaiting_Shipment",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIALLY_SHIPPED: {
    text: "Partially_Shipped",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PACKED: { text: "Packed", style: ORDERSTATUS_POSITIVE_STYLE },
  PICKED: { text: "Picked", style: ORDERSTATUS_POSITIVE_STYLE },
  PARTIALLY_PICKED: {
    text: "Partially_Picked",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIALLY_CANCELLED: {
    text: "Partially_Cancelled",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  PARTIALLY_DELIVERED: {
    text: "Partially_Delivered",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PAYMENT_CANCELLED: {
    text: "Payment_Cancelled",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  IN_TRANSIT: { text: "In_Transit", style: ORDERSTATUS_POSITIVE_STYLE },
  DELIVERED: { text: "Delivered", style: ORDERSTATUS_POSITIVE_STYLE },
  CREATED: { text: "Processing", style: ORDERSTATUS_POSITIVE_STYLE },
  PAYMENT_PENDING: {
    text: "Payment_Pending",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  SHIPMENT_CREATED: {
    text: "Shipment_Created",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  OUT_FOR_DELIVERY: {
    text: "Out For Delivery",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
};
*/

// Map order statuses to text and styles
export const STATUS_MAP = {
  PAYMENT_SUCCESS: {
    text: "Processing",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PAYMENT_FAILED: { text: "Failed", style: ORDERSTATUS_NEGATIVE_STYLE },
  PAYMENT_PENDING: {
    text: "Payment_Pending",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  CANCELLED: { text: "Cancelled", style: ORDERSTATUS_NEGATIVE_STYLE },
  SHIPPED: { text: "Shipped", style: ORDERSTATUS_POSITIVE_STYLE },
  AWAITING_SHIPMENT: {
    text: "Awaiting_Shipment",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIALLY_SHIPPED: {
    text: "Partially_Shipped",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PACKED: { text: "Packed", style: ORDERSTATUS_POSITIVE_STYLE },
  PICKED: { text: "Picked", style: ORDERSTATUS_POSITIVE_STYLE },
  PARTIALLY_PICKED: {
    text: "Partially_Picked",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIALLY_CANCELLED: {
    text: "Partially_Cancelled",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  PARTIALLY_DELIVERED: {
    text: "Partially_Delivered",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PAYMENT_CANCELLED: {
    text: "Payment_Cancelled",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  IN_TRANSIT: { text: "In_Transit", style: ORDERSTATUS_POSITIVE_STYLE },
  DELIVERED: { text: "Delivered", style: ORDERSTATUS_POSITIVE_STYLE },
  CREATED: { text: "Processing", style: ORDERSTATUS_POSITIVE_STYLE },
  SHIPMENT_CREATED: {
    text: "Shipment_Created",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIAL_SHIPMENT_CREATED: {
    text: "Partial_Shipment_Created",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  PARTIALLY_NOT_DELIVERED: {
    text: "Partially_Not_Delivered",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  PARTIALLY_OUT_FOR_DELIVERY: {
    text: "Partially_Out_For_Delivery",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  NOT_DELIVERED: {
    text: "Not_Delivered",
    style: ORDERSTATUS_NEGATIVE_STYLE,
  },
  OUT_FOR_DELIVERY: {
    text: "Out_For_Delivery",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
  SHIPMENT_REPROCESSING: {
    text: "Shipment_Reprocessing",
    style: ORDERSTATUS_POSITIVE_STYLE,
  },
};

export const PROFILE_FORM_FIELDS = [
  {
    id: 1,
    name: "firstName",
    label: "First_Name",
    placeholder: "First_Name",
    type: "input",
  },
  {
    id: 2,
    name: "lastName",
    label: "Last_Name",
    placeholder: "Last_Name",
    type: "input",
  },
  {
    id: 3,
    name: "email",
    label: "Email_Address",
    placeholder: "Email_Address",
    type: "input",
  },
  {
    id: 4,
    name: "phoneNumber",
    label: "Phone_Number",
    placeholder: "Phone_Number",
    type: "input",
  },
  {
    id: 5,
    name: "gender",
    label: "Gender",
    placeholder: "Select_Gender",
    type: "select",
    options: [
      { label: "Select_Gender", value: "" },
      { label: "Male", value: "male" },
      { label: "Female", value: "female" },
    ],
  },
];

export const CHANGE_PASSWORD_FORM_FIELDS = [
  {
    id: 1,
    name: "oldPassword",
    label: "Old_Password",
    placeholder: "Min_8_Characters",
    type: "input",
  },
  {
    id: 2,
    name: "newPassword",
    label: "New_Password",
    placeholder: "Min_8_Characters",
    type: "input",
  },
  {
    id: 3,
    name: "confirmNewPassword",
    label: "Confirm_New_Password",
    placeholder: "Min_8_Characters",
    type: "input",
  },
];

export const INITIAL_ADDRESS_FORM_VALUES = {
  title: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  country: "Saudi Arabia",
  state: "NA",
  city: "",
  email: "",
  zipCode: "",
  line1: "",
  street: "",
  defaultAddress: false,
};

export const ADDRESS_FORM_FIELDS = [
  {
    id: 1,
    name: "title",
    label: "Address_Title",
    placeholder: "Eg_Home",
    type: "input",
  },
  {
    id: 2,
    name: "firstName",
    label: "First_Name",
    placeholder: "Eg_John",
    type: "input",
  },
  {
    id: 3,
    name: "lastName",
    label: "Last_Name",
    placeholder: "Eg_Doe",
    type: "input",
  },
  {
    id: 4,
    name: "email",
    label: "Email_Address",
    placeholder: "Eg_You_@_Example_com",
    type: "input",
  },
  {
    id: 5,
    name: "phoneNumber",
    label: "Phone_Number",
    placeholder: "Eg_55_123_4567",
    type: "input",
  },
  {
    id: 10,
    name: "street",
    label: "Street",
    placeholder: "Eg_Al-Bat'ha",
    type: "input",
  },
  {
    id: 9,
    name: "line1",
    label: "Address",
    placeholder: "Eg_Apartment_12_Building_5",
    type: "input",
  },
  {
    id: 7,
    name: "city",
    label: "City",
    placeholder: "Eg_Dammam_City",
    type: "select",
  },
  {
    id: 8,
    name: "zipCode",
    label: "Postal_Code",
    placeholder: "Eg_31441",
    type: "input",
  },
  {
    id: 6,
    name: "country",
    label: "Country",
    placeholder: "Country",
    readOnly: true,
    disabled: true,
    type: "input",
  },
  {
    id: 11,
    name: "defaultAddress",
    label: "Default_Address",
    placeholder: "",
    type: "checkbox",
  },
];

export const INITIAL_REGISTER_FORM_VALUES = {
  password: "",
  confirm: "",
  email: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
};

export const REGISTER_FORM_FIELDS = [
  {
    id: 1,
    name: "firstName",
    label: "First_Name",
    placeholder: "Eg_John",
    type: "input",
  },
  {
    id: 2,
    name: "lastName",
    label: "Last_Name",
    placeholder: "Eg_Doe",
    type: "input",
  },
  {
    id: 3,
    name: "email",
    label: "Email",
    placeholder: "Eg_You_@_Example_com",
    type: "input",
  },
  {
    id: 4,
    name: "phoneNumber",
    label: "Phone_Number",
    placeholder: "Eg_+966_55_123_4567",
    type: "input",
  },
  {
    id: 5,
    name: "password",
    label: "Password",
    placeholder: "Min_8_Characters",
    type: "password",
  },
  {
    id: 6,
    name: "confirm",
    label: "Confirm_Password",
    placeholder: "Min_8_Characters",
    type: "password",
  },
];

export const CANCEL_ORDER_REASON = [
  {
    value: "",
    label: "Select_Cancel_Reason",
  },
  {
    value: "Changed my mind",
    label: "Changed_My_Mind",
  },
  {
    value: "Found a better price",
    label: "Found_Better_Price",
  },
  {
    value: "Shipping took too long",
    label: "Shipping_Took_Too_Long",
  },
  {
    value: "Ordered by mistake",
    label: "Ordered_By_Mistake",
  },
  {
    value: "Product not needed anymore",
    label: "Product_Not_Needed",
  },
  {
    value: "Incorrect product ordered",
    label: "Incorrect_Product_Ordered",
  },
  {
    value: "Product description was unclear or inaccurate",
    label: "Product_Description_Unclear",
  },
  {
    value: "Prefer a different item",
    label: "Prefer_Different_Item",
  },
  {
    value: "Delayed shipping notification",
    label: "Delayed_Shipping_Notification",
  },
  {
    value: "Order placed in error by another person",
    label: "Order_Placed_In_Error",
  },
  {
    value: "Other",
    label: "Other",
  },
];
